import { render, staticRenderFns } from "./CardMain.vue?vue&type=template&id=1b90a539&scoped=true"
import script from "./CardMain.vue?vue&type=script&lang=js"
export * from "./CardMain.vue?vue&type=script&lang=js"
import style0 from "./CardMain.vue?vue&type=style&index=0&id=1b90a539&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b90a539",
  null
  
)

export default component.exports